import { api } from "./api";
import { PUT } from "./consts";

export const roleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get user roles
    getUserRoles: builder.query<string[], string>({
      query: (user_id) => `/api/role/v1/${user_id}`,
      providesTags: ["User"],
    }),
    // Update user roles
    updateUserRoles: builder.mutation<
      void,
      { org_user_id: string; roles: string[] }
    >({
      query: ({ org_user_id, roles }) => ({
        url: `/api/role/v1/${org_user_id}`,
        method: PUT,
        body: roles,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const { useGetUserRolesQuery, useUpdateUserRolesMutation } = roleApi;
